import { AvenueItem } from '@common/components/Avenue';
import { Collection, useSelectCollection } from '@features/Collection';
import { Button, Inset, Skeleton, Text } from '@radix-ui/themes';

import { createCollectionDetailsPagePath } from '@router';
import { useNavigate } from 'react-router-dom';

import { Avatar } from 'radix-ui';
import React from 'react';
import styles from './CollectionCard.module.css';
import { CollectionCardOverlay } from './CollectionCardOverlay';
import { useCollectionMetadata } from '@features/metadata';

type CollectionItem = Collection & AvenueItem;

interface CollectionCardProps {
    collection: CollectionItem;
}

export const CollectionCard = ({ collection }: CollectionCardProps) => {
    const [isHovered, setIsHovered] = React.useState(false);
    const { selectCollection } = useSelectCollection();
    const navigate = useNavigate();
    const { title: encodedTitle, id: collectionId, proscopeId } = collection;
    const { data: metadata, isLoading } = useCollectionMetadata({
        collectionId,
        proscopeId,
    });

    const { title, images } = metadata;
    const { url } = images.cover;

    const handleOnClick = () => {
        selectCollection(collection.id);
        navigate(createCollectionDetailsPagePath(collectionId));
    };

    return (
        <Button
            className={styles.card}
            variant={'outline'}
            onClick={handleOnClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            asChild
        >
            <Inset clip={'border-box'} side={'all'} p={'current'}>
                <Skeleton loading={isLoading}>
                    <Avatar.Root className={styles.avatar}>
                        <Avatar.Image
                            className={styles.avatarImage}
                            width={'100%'}
                            height={'100%'}
                            src={url}
                            alt={title}
                        />

                        <Avatar.Fallback
                            className={styles.avatarFallback}
                            asChild
                        >
                            <Text color={'gray'} highContrast>
                                {title || encodedTitle}
                            </Text>
                        </Avatar.Fallback>
                    </Avatar.Root>
                </Skeleton>

                {isHovered && (
                    <CollectionCardOverlay
                        collection={collection}
                        metadata={metadata}
                    />
                )}
            </Inset>
        </Button>
    );
};
